import { z } from 'zod'
import { ModuleName, ModuleStatusValue } from '../constants/s360app-compat'

export const moduleActivateSchema = z.object({
  client_id: z.string().min(1, 'Client ID is required'),
  module: ModuleName,
})

export const moduleUpdateSchema = z.object({
  status: ModuleStatusValue,
  metadata: z.string().optional(),
})
